import Modernization from './Template'

export default Modernization
